import { ScatterplotLayer, ScatterplotLayerProps } from "@deck.gl/layers";
import { useSelector } from "react-redux";

import { XYLocation } from "@nens/deck-gl";

import { getHoverCircleCoordinates } from "../../state/map";

import { STATIC_COLORS } from "./DeckGlConsts";

const useMapHoverCircle = () => {
  const coordinates = useSelector(getHoverCircleCoordinates);

  const defaultScatterplotLayerProps = {
    filled: true,
    getPosition: (d: XYLocation) => {
      return d;
    },
    getRadius: 15,
    radiusUnits: "pixels",
    getFillColor: STATIC_COLORS.LEVEE_EDIT,
  } as unknown as ScatterplotLayerProps;
  return new ScatterplotLayer({
    ...defaultScatterplotLayerProps,
    id: "hover-circle-point-layer",
    data: coordinates ? [coordinates] : [],
  });
};

export default useMapHoverCircle;
